// This import loads the firebase namespace along with all its type information.
import ContentHouse from './content-house-model'

export async function load_contentHouses(): Promise<ContentHouse[]> {
  throw 'Not implemented'
}

export async function delete_contentHouse(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_contentHouse(): Promise<ContentHouse> {
  throw 'Not implemented'
}
